import { render, staticRenderFns } from "./project.vue?vue&type=template&id=77a91261&scoped=true&"
import script from "./project.vue?vue&type=script&lang=js&"
export * from "./project.vue?vue&type=script&lang=js&"
import style0 from "./project.vue?vue&type=style&index=0&id=77a91261&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a91261",
  null
  
)

export default component.exports